// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-G":"G_power-ocean-collection-G__n1ANt"};